const getUserAgentFromServer = (req) => ({
  get: () => req.get('User-Agent'),
});

const getUserAgentFromClient = () => ({
  get: () => navigator.userAgent,
});

export const initUserAgent = (...args) => {
  return __SERVER__
    ? getUserAgentFromServer(...args)
    : getUserAgentFromClient(...args);
};
